import React, { useState, useEffect } from "react";
import moment from "moment";
import DataTile from "./controls/DataTile";
import DateBox from "./controls/DateBox";
import SearchBox from "./controls/SearchBox";
import Axios from "axios";
import { AgentsRequests } from "../apiRequests/AgentsRequests";
import { DateFormatter } from "./common/DateFormatter";
import Uploader from "./controls/Uploader";
import * as constants from "../constants";
import Loader from "./common/Loader";
import NoDataImg from "../assets/images/NoData.webp";

const dateFormatter = new DateFormatter();
const agentsRequests = new AgentsRequests();

const DocumentsView = () => {
  const [dataEmpty, setDataEmpty] = useState("hidden");
  const [hidden, setHidden] = useState("hidden");
  const [isSubmit, setIsSubmit] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [documentsData, setDocumentsData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [filteredDocumentsData, setFilteredDocumentsData] = useState([]);
  const [fromDateState, setFromDate] = useState(localStorage.getItem("t4StartDate"));
  const [toDateState, setToDate] = useState(localStorage.getItem("t4EndDate"));
  const [expanded, setExpanded] = useState("");
  const [value, setValue] = useState("");
  const [background, setBackground] = useState("hidden");
  const [uploadFileState, setUploadFileState] = useState(null);
  const [popUpMessage, setPopUpMessage] = useState({ type: '', text: '' });
  function agentDocumentsFn(startDate, endDate) {
    setHidden("");
    setIsLoaded(true);
    agentsRequests.agentDocuments(startDate, endDate).then((result) => {
      let documentsData = result;
      if (documentsData !== "error") {
        setDocumentsData(documentsData);
        setFilteredDocumentsData(documentsData);
        setHidden("hidden");
        setIsLoaded(false);
      } else {
        setDataEmpty("");
      }
    });
  };

  const searchHandeler = () => {
    var searchValue = document.getElementById("search").value;
    setValue(searchValue);
    let data = documentsData;

    if (searchValue !== "") {
      data = data.filter((object) =>
        object.docName.toUpperCase().includes(searchValue.toUpperCase())
      );
    }

    if (data.length === 0) {
      setDataEmpty("");
    } else {
      setDataEmpty("hidden");
    }

    setFilteredDocumentsData(data);
  };

  const dateStr = (date) => {
    let uDate = moment(date, "DD/MM/YYYY");
    return "Uploaded on: " + moment(uDate).format("DD-MM-YYYY");
  };

  const handleDateBox = (e, name) => {
    let selectedDate = e;
    const fromDate = new Date(dateFormatter.formatterThree(fromDateState));
    let toDate = new Date(dateFormatter.formatterThree(toDateState));
    let sDate = new Date(dateFormatter.formatterThree(selectedDate));

    if (name === "FromDate") {
      let startDate = dateFormatter.formatterTwo(sDate);
      let endDate = dateFormatter.formatterTwo(toDate);
      localStorage.setItem("t4StartDate", startDate);
      localStorage.setItem("dateRangeLabel4", "Custom Range");
      setFromDate(selectedDate);
      setIsOpen(false);
      setExpanded("");
      setBackground("hidden");
      agentDocumentsFn(startDate, endDate);
    } else if (name === "ToDate") {
      let startDate = dateFormatter.formatterTwo(fromDate);
      let endDate = dateFormatter.formatterTwo(sDate);
      localStorage.setItem("t4EndDate", endDate);
      localStorage.setItem("dateRangeLabel4", "Custom Range");
      setToDate(selectedDate);
      setIsOpen(false);
      setExpanded("");
      setBackground("hidden");
      agentDocumentsFn(startDate, endDate);
    }
  };

  const uploaderPanel = () => {
    if (expanded) {
      setIsOpen(false);
      setExpanded("");
      setBackground("hidden");
    } else {
      setIsOpen(true);
      setExpanded("yes");
      setBackground("");
    }
  };

  const renderTiles = () => {
    let documentsData = filteredDocumentsData;
    if (documentsData.length >= 1) {
      return (
        <div className="bg-white dark:bg-white/5 max-h-[600px] mt-24 shadow rounded-lg overflow-auto">
          <div className="p-6 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-5 ">
            {documentsData.map((object, index) => (
              <div key={"id" + index}>
                <DataTile
                  id={"id" + index}
                  svgType={object.docName.slice(
                    (Math.max(0, object.docName.lastIndexOf(".")) || Infinity) +
                    1
                  )}
                  title={object.docName}
                  description2={
                    <div className="grid grid-cols-7">
                      <div className="col-span-6">
                        <p> {object.docSize && "Size: " + object.docSize}</p>
                      </div>
                      <div className="col-span-1 pt-3">
                        <a
                          className="hover:text-blue-500 text-sm text-blue-400 hover:font-semibold cursor-pointer flex justify-end"
                          href={object.downloadLink}
                        >
                          <svg
                            className="w-5 h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                            />
                          </svg>
                        </a>
                      </div>
                    </div>
                  }
                  description1={
                    <div className="">
                      {dateStr(object.uploadDate)}
                    </div>
                  }
                />
              </div>
            ))}
          </div>
        </div>
      );
    } else {
      return (
        <div className="flex flex-col bg-white items-center mt-24 rounded-md dark:bg-white/5 justify-center py-12 text-gray-600">
          <img src={NoDataImg} alt="No data" className="w-40 h-auto mb-4" />
          <h2 className="text-xl font-semibold dark:text-white">No Data to Display</h2>
          <p className="text-sm text-gray-500 mt-1 dark:text-gray-400">Try resetting filters or changing your criteria.</p>
        </div>
      );
    }
  };

  const upload = (file, docTypeId) => {
    setUploadFileState(file);
  };

  const uploadFile = async () => {
    var file = uploadFileState;
    const objectType = 4;
    const objectID = localStorage.getItem("agentId"); //Applicant Id
    if (file) {
      if (file.length > 0) {
        setHidden("");
        setIsLoaded(true);
        let form = new FormData();

        form.append("file", file[0]);
        form.append("objectId", objectID);
        form.append("objectType", objectType);
        form.append("isPublic", 1);

        try {
          setIsSubmit(true)
          await Axios.post(constants.BASEURL + "Document", form).then((result) => {
            if ((result.data.sucess = false)) {
              alert("Fail");
            } else {
              setHidden("hidden");
              setIsLoaded(false);
              setIsOpen(false);
              setBackground("hidden");
              // alert("Success");
              setPopUpMessage({ type: 'success', text: "Document uploaded successfully." });
            }
          });
        } catch (e) {
          // alert("Error while uploading ");
          setPopUpMessage({ type: 'danger', text: "Error while Uploading document." });
        }
        finally{
          setIsSubmit(false)
        }
      }
    }
  };

  useEffect(() => {
    let startDate = dateFormatter.formatterTwo(localStorage.getItem("t4StartDate"));
    let endDate = dateFormatter.formatterTwo(localStorage.getItem("t4EndDate"));
    agentDocumentsFn(startDate, endDate);
    setDataEmpty("")
  }, []);

  return (
    <div className="relative mt-6 align-middle min-h-full">
      <span
        className={
          hidden +
          " z-10 fixed top-12 left-0 right-0 bottom-0 w-full bg-white opacity-25"
        }
      />

      {popUpMessage.text && (
          <div className="fixed top-4 right-4 z-50 mt-10 mr-4 max-w-sm w-full">
              <div
                  className={`border px-4 py-3 rounded relative shadow-md ${
                      popUpMessage.type === 'success'
                          ? 'bg-green-100 border-green-400 text-green-700'
                          : 'bg-red-100 border-red-400 text-red-700'
                  }`}
                  role="alert"
              >
                  <span className="block sm:inline">{popUpMessage.text}</span>
                  <button
                      className="absolute top-0 bottom-0 right-0 px-4 py-3"
                      onClick={() => setPopUpMessage({ type: '', text: '' })}
                  >
                      <span className={popUpMessage.type === 'success' ? 'text-green-700' : 'text-red-700'}>
                          &times;
                      </span>
                  </button>
              </div>
          </div>
      )}

      <Loader loaded={isLoaded} id={"documentview"} hidden={hidden} />
      <div className="col-span-6 text-left text-2xl text-blue-500 mb-4 font-semibold dark:text-white">Document Listing</div> 
      <div className="rounded-md p-4 bg-white mb-4 md:mb-8 w-full grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-6 dark:bg-white/10 shadow-md">
        <div className="xl:col-span-2">
          <SearchBox
            id="search"
            label={"Search For Document"}
            svgType={"document"}
            placeholder={"Name"}
            value={value}
            searchHandler={() => {
              searchHandeler();
            }}
          />
        </div>

        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Ud1"}
            label="Upload Date From"
            //minDate={moment().add(0, "days").toDate()}
            onChange={handleDateBox}
            name={"FromDate"}
            value={fromDateState ? new Date(fromDateState) : ""}
          />
        </div>
        <div className="xl:col-span-2">
          <DateBox
            dependentOn={true}
            id={"Ud1"}
            label="Upload Date Till"
            //minDate={moment().add(0, "days").toDate()}
            onChange={handleDateBox}
            name={"ToDate"}
            value={toDateState ? new Date(toDateState) : ""}
          //onChange={this.handleChange}
          />
        </div>
      </div>

      <div>
        <button
          onClick={() => uploaderPanel()}
            className={`absolute right-0 focus:outline-none text-white hover:bg-blue-800 focus:ring-2 dark:ring-0 font-medium rounded-lg text-sm px-4 py-1.5 me-2 mb-2 ${isOpen ? "bg-blue-700 text-white dark:bg-white/20" : "bg-blue-500 hover:dark:bg-white/20 dark:bg-white/10 dark:text-white"}`}
          >
          +
        </button>
      </div>

      <div
        className={`${
          isOpen ? "" : "hidden"
        } fixed top-16 left-0 right-0 bottom-0 z-20 bg-black/20 dark:bg-white/20 backdrop-blur-sm flex items-center justify-center`}
      >
        <div className="bg-white dark:bg-[#2C2C2E] w-[70%] max-w-2xl p-6 rounded-lg shadow-lg">
          
          <div className="text-right mb-4">
            <button
              className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white"
              onClick={() => {
                setIsOpen(false);
                setExpanded("");
                setBackground("hidden");
              }}
            >
              &#10006;
            </button>
          </div>

          <div className="mb-6">
            <Uploader
              onUpload={(file, docTypeId) => {
                upload(file, docTypeId);
              }}
              docTypeId={"AgentDocuments"}
            />
          </div>

          <div className="border-t border-gray-200 dark:border-gray-500 pt-4 flex justify-center">
            <button
              id="submit"
              type="button"
              onClick={uploadFile}
              className="px-6 py-2 bg-blue-500 text-white text-sm font-medium rounded hover:bg-blue-600 focus:outline-none"
              disabled={isSubmit}
            >
              {isSubmit ? "Submitting..." : "Submit"}
            </button>
          </div>

        </div>
      </div>


      <div className="">
        <span
          onClick={() => uploaderPanel()}
          className={
            background +
            " z-10  top-8 left-0 right-0 bottom-0 w-full bg-gray-400 opacity-75"
          }
        />
      </div>

      {renderTiles()}
    </div>
  );
};

export default DocumentsView;
